
import UploadFileServices from '@/services/UploadFileServices';
import serverConfig from "@/config/ServerConfig";

const state = {
    urlUploadFile: null
}
const getters = {
    uploadFileUrl: state => {
        return state.urlUploadFile;
    }
}
const actions = {
   uploadFile(context, formData) {
       return UploadFileServices.uploadFile(formData)
        .then(res=>{
            context.commit('showUrl',res.data.data.path);
            return res;
		})
    },    
}
const mutations = {
    showUrl(state,urlFile) {
        state.urlUploadFile = 'https://fms.aseguradoradelsur.'+serverConfig+urlFile;
    }
}

export default
    {
        state,
        actions,
        mutations,
        getters
    }